module.exports = __webpack_public_path__ + "static/Set-Variant-WT-5bc2e69bcfafb866ecb6c45fdb24cd32.png";